import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_10,
  OL_COLOUR_BLACK_4,
  OL_COLOUR_TOMAHTO,
} from '../../../Style/colours';
import {
  FLOW_MODAL_ACTION_BAR_PADDING,
  FLOW_MODAL_CONTENT_PADDING,
  FLOW_MODAL_SINGLE_COLUMN_CONTENT_MAX_WIDTH,
} from '../constants';
import { FlowModalContentType } from '../types';

export const Page = styled('div')({
  display: 'flex',
  width: '100%',
  overflow: 'hidden',
});

export const Main = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 1,
  flexGrow: 1,
  alignItems: 'stretch',
  overflow: 'auto',
  background: '#ffffff',
});

export const Content = styled('div')<{ contentType: FlowModalContentType }>(
  ({ contentType }) => ({
    padding:
      contentType === FlowModalContentType.FullWidth
        ? FLOW_MODAL_CONTENT_PADDING
        : contentType === FlowModalContentType.FixedWidth
        ? `${FLOW_MODAL_CONTENT_PADDING}px 0`
        : 0,
    maxWidth:
      contentType === FlowModalContentType.FixedWidth
        ? FLOW_MODAL_SINGLE_COLUMN_CONTENT_MAX_WIDTH
        : 'none',
    margin:
      contentType === FlowModalContentType.FullWidth ||
      contentType === FlowModalContentType.Raw
        ? '0'
        : '0 auto',
  })
);

export const Footer = styled('div')({
  padding: FLOW_MODAL_ACTION_BAR_PADDING,
  margin: '0 auto',
  borderTop: `1px solid ${OL_COLOUR_BLACK_10}`,
  background: OL_COLOUR_BLACK_4,
  width: '100%',
});

export const ErrorMessage = styled('div')({
  textAlign: 'right',
  color: OL_COLOUR_TOMAHTO,
  paddingBottom: 10,
});

export const Buttons = styled('div')({
  display: 'flex',
  flexDirection: 'row-reverse',
  justifyContent: 'space-between',
});

export const ButtonsRight = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',

  '& > *': {
    marginLeft: 20,
  },
});

export const ButtonsLeft = styled('div')({
  display: 'flex',

  '& > *': {
    marginRight: 20,
  },
});
